var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 203 203",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M185 132l-53 0 0 -20 -13 0 0 -21c0,-8 3,-14 8,-19 10,-7 15,-19 15,-31 0,-12 -5,-23 -13,-31 -9,-7 -21,-11 -32,-10 -18,2 -33,17 -36,35 -2,14 4,28 15,37 5,5 9,12 9,19l0 21 -14 0 0 20 -53 0c-4,0 -8,4 -8,8l0 38c0,5 4,8 8,8l3 0c1,10 10,17 20,17l122 0c10,0 18,-7 20,-17l2 0c4,0 8,-3 8,-8l0 -38c0,-4 -4,-8 -8,-8zm-105 -65c-9,-8 -14,-19 -12,-31 2,-15 15,-27 30,-29 9,-1 19,2 26,8 7,7 11,16 11,26 0,10 -4,20 -12,26 -7,6 -11,14 -11,24l0 21 -21 0 0 -21c0,-9 -4,-18 -11,-24zm-2 52l7 0 34 0 6 0 0 13 -47 0 0 -13zm85 77l-122 0c-7,0 -12,-4 -13,-10l148 0c-2,6 -7,10 -13,10zm23 -18c0,1 0,1 -1,1l-2 0 -163 0 -2 0c0,0 -1,0 -1,-1l0 -38c0,-1 1,-1 1,-1l53 0 61 0 53 0c1,0 1,0 1,1l0 38z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentAccount);
export default __webpack_public_path__ + "static/media/PaymentAccount.d458b8620df1732f2932ead37fa84c9a.svg";
export { ForwardRef as ReactComponent };